/**
  * @fileoverview A function for making XmlHttpRequests.
  *
  * @author Stephanie Yoon (steyoon@yext.com)
  */

import Uri from 'goog:goog.Uri';
import json from 'goog:goog.json';
import ErrorCode from 'goog:goog.net.ErrorCode';
import XhrIo from 'goog:goog.net.XhrIo';

// this map is to ensure that if a particular request is re-sent, only the newest request will be
// completed and the older request is aborted.
const currentRequests = new Map();

/**
 * @param {string} key
 * @param {AbortSignal} abortSignal
 * @param {!Uri} uri
 * @param {string} method
 * @param {Object=} body
 *
 * @return {!Promise}
 */
export const doRequest = (key, abortSignal, uri, method, body) => {
  if (abortSignal.aborted) {
    return Promise.reject(true);
  }
  if (currentRequests.has(key)) {
    currentRequests.get(key).abort();
  }

  return new Promise((resolve, reject) => {
    const xhr = XhrIo.send(
      uri,
      e => {
        currentRequests.delete(key);
        if (e.target.isSuccess()) {
          resolve(e.target.getResponseJson());
        } else {
          reject(e.target.getLastErrorCode() == ErrorCode.ABORT);
        }
      },
      method,
      body == null ? null : json.serialize(body),
      {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    );
    currentRequests.set(key, xhr);
    abortSignal.onabort = () => xhr.abort();
  });
};
